import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '@/views/uc-web/index.vue';
import Login from '@/views/uc-web/Login/index.vue';
import Home from '@/views/uc-web/Detail/index.vue';
import CheckPreview from '@/views/uc-web/CheckPreview/index.vue';
import TokenLogin from '@/views/uc-web/TokenLogin/index.vue';
import BigLogin from '@/views/uc-web/BigLogin/index.vue';
import HomePage from '@/views/uc-web/HomePage/index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/uc-web',
    redirect: '/uc-web/login',
  },
  {
    path: '/uc-web/login',
    name: 'Login',
    component: Login,
    meta: {
      permission: false,
    },
  },
  {
    path: '/uc-web/tokenLogin',
    name: 'TokenLogin',
    component: TokenLogin,
    meta: {
      permission: false,
    },
  },
  {
    path: '/uc-web/bigLogin',
    name: 'BigLogin',
    component: BigLogin,
    meta: {
      permission: false,
    },
  },
  {
    path: '/uc-web/homePage',
    name: 'HomePage',
    component: HomePage,
    meta: {
      permission: false,
    },
  },
  {
    path: '/uc-web/center',
    name: 'Home',
    component: Home,
    meta: {
      permission: false,
    },
  },
  {
    path: '/uc-web/preview',
    name: 'CheckPreview',
    component: CheckPreview,
    meta: {
      permission: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
